import { Controller, FieldValues } from 'react-hook-form'
import classNames from 'classnames'
import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import { DatePickerProps } from './types'
import { FormError } from '.'

const DatePicker = <T extends FieldValues>({
  className,
  label,
  name,
  control,
  required,
  emptyValue,
  isEditing,
  onFieldChange,
  ...rest
}: DatePickerProps<T>) => {
  if (!name) return null

  return (
    <label className={className}>
      {!!label && (
        <span className={classNames('name', { required: !!required })}>
          {label} {!!required && <sup>*</sup>}
        </span>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <>
            {emptyValue && [undefined, null, ''].includes(value) ? (
              <div className="empty-value">{emptyValue}</div>
            ) : (
              <ReactDatePicker
                shouldCloseOnSelect
                // @ts-ignore
                selected={typeof value === 'string' ? new Date(value) : value}
                // @ts-ignore
                onChange={d => {
                  onChange(d)
                  onFieldChange?.(d)
                }}
                dateFormat="dd/MM/yyyy"
                portalId="root-portal"
                {...rest}
              />
            )}

            {isEditing && <FormError error={error?.message} />}
          </>
        )}
      />
    </label>
  )
}

export default DatePicker
